export const formatNumber = (number: number) => {
    if (typeof number !== "number") {
        return number;
    }
    const roundedNumber = Math.round(number);
    return roundedNumber.toLocaleString("ru-RU", { style: "decimal" });
};

export const randomNumberFrom1To12 = () => {
    let randomNumber = Math.random();

    let roundedRandomNumber = Math.floor(randomNumber * 11);

    return roundedRandomNumber + 1;
};

interface IObject {
    name: string;
    description: string;
    button: {
        text: string;
        boughtText: string;
    };
    img: string;
    cost: string;
    unique_key: string;
    type: string;
}

export const clone = (obj: IObject) => {
    const copy = {};

    for (const key in obj) {
        //@ts-ignore
        const value = obj[key];

        if (typeof value === "object") {
            //@ts-ignore
            copy[key] = clone(value);
        } else {
            //@ts-ignore
            copy[key] = value;
        }
    }

    return copy;
};
